<script setup lang="ts">
// import layoutQuery from '~layers/app/graphql/layout.gql'

const pageComponent = defineAsyncComponent(() => import('~layers/app/pages/~cms.vue'))

const { public: config } = useRuntimeConfig()
// const { data } = await useAsyncQuery(layoutQuery, { locale: config.strapiLocale, status: 'PUBLISHED' })

const { data: response } = await useAsyncGraphqlQuery('layout', {
  locale: config.strapiLocale,
  status: 'PUBLISHED',
}, useGraphqlDefaultClient())

const { searchSnippet } = useSeo()
searchSnippet()

const meta = computed(() => {
  return {
    id: `strapi-${response?.value?.data?.home?.[0]?.documentId}`,
    url: '',
    page_type: 'cms-page',
    strapi_id: response?.value?.data?.home?.[0]?.documentId,
    label: 'Home',
  }
})

provide('meta', meta)
</script>

<template>
  <component :is="pageComponent" />
</template>
